import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'cat-beginner': 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20dungeon%20entrance%20with%20glowing%20torchlight%20on%20stone%20walls%2C%20ancient%20wooden%20signpost%20with%20mysterious%20runes%2C%20warm%20amber%20lighting%20creating%20long%20shadows%2C%20cinematic%20game%20concept%20art%20style%20with%20painterly%20textures%2C%20atmospheric%20depth%2C%20rich%20dark%20brown%20and%20gold%20tones&width=800&height=600&seq=cat-beginner&orientation=landscape',
  'cat-characters': 'https://readdy.ai/api/search-image?query=Fantasy%20character%20lineup%20of%20adventurers%20in%20dark%20underground%20cave%20setting%2C%20warrior%20mage%20and%20rogue%20silhouettes%20against%20torch-lit%20stone%20background%2C%20dramatic%20rim%20lighting%2C%20dark%20fantasy%20illustration%20style%20with%20warm%20amber%20highlights%2C%20moody%20atmospheric%20composition&width=800&height=600&seq=cat-characters&orientation=landscape',
  'cat-story': 'https://readdy.ai/api/search-image?query=Ancient%20underground%20library%20with%20crumbling%20stone%20shelves%20and%20glowing%20magical%20scrolls%2C%20mysterious%20green%20luminescent%20crystals%20embedded%20in%20cave%20walls%2C%20dark%20fantasy%20atmosphere%20with%20emerald%20and%20amber%20light%20interplay%2C%20painterly%20concept%20art%20with%20rich%20textural%20detail&width=800&height=600&seq=cat-story&orientation=landscape',
  'cat-map': 'https://readdy.ai/api/search-image?query=Detailed%20fantasy%20dungeon%20map%20spread%20across%20weathered%20parchment%20on%20stone%20table%2C%20with%20compass%20rose%20and%20mysterious%20markings%2C%20candlelight%20illumination%20casting%20warm%20glow%2C%20cartography%20aesthetic%20with%20ink%20and%20aged%20paper%20textures%2C%20dark%20ambient%20atmosphere&width=800&height=600&seq=cat-map&orientation=landscape',
  'cat-equipment': 'https://readdy.ai/api/search-image?query=Display%20of%20fantasy%20weapons%20and%20armor%20arranged%20on%20dark%20stone%20pedestal%20in%20underground%20forge%2C%20glowing%20enchanted%20sword%20and%20shield%20reflecting%20firelight%2C%20warm%20forge%20fire%20illuminating%20the%20scene%2C%20dark%20fantasy%20still%20life%20with%20rich%20metallic%20textures%20and%20amber%20highlights&width=800&height=600&seq=cat-equipment&orientation=landscape',
  'cat-boss': 'https://readdy.ai/api/search-image?query=Massive%20goblin%20king%20boss%20towering%20in%20dark%20cave%20throne%20room%2C%20surrounded%20by%20treasure%20hoard%20and%20glowing%20crystals%2C%20dramatic%20confrontation%20scene%20with%20epic%20scale%2C%20dark%20fantasy%20illustration%20with%20intense%20amber%20and%20emerald%20lighting%2C%20cinematic%20composition&width=800&height=600&seq=cat-boss&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索攻略分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            无论你是初入洞穴的新手还是征战多年的老玩家，这里都有你需要的攻略内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={categoryImages[cat.imageSeq]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4 flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-background-50 text-lg`}></i>
                  </div>
                  <h3 className="text-background-50 font-heading font-bold text-lg">
                    {cat.name}
                  </h3>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇攻略
                  </span>
                  <span className="text-primary-600 text-sm font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    查看全部 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}